import { VisibleTimeRange } from '../lib/visible-time-range';

/**
 * Time window stored as epoch milliseconds (stable for equality and Zustand updates).
 */
export type MsTimeRange = {
  fromMs: number;
  toMs: number;
};

/**
 * Parses report `data.from` / `data.to` into a valid millisecond range, or null if invalid.
 */
export function parseReportWindowMs(fromIso: string, toIso: string): MsTimeRange | null {
  const fromMs = new Date(fromIso).getTime();
  const toMs = new Date(toIso).getTime();
  if (Number.isNaN(fromMs) || Number.isNaN(toMs) || !(toMs > fromMs)) {
    return null;
  }
  return { fromMs, toMs };
}

/**
 * Converts a visible range to millisecond bounds.
 */
export function visibleRangeToMs(range: VisibleTimeRange): MsTimeRange {
  return { fromMs: range.from.getTime(), toMs: range.to.getTime() };
}
